import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const CATEGORIES = [
  { slug: "engineering", label: "Engineering Colleges" },
  { slug: "university", label: "Universities" },
  { slug: "medical", label: "Medical Colleges" },
  { slug: "mba", label: "MBA / Management" },
  { slug: "school", label: "Schools" },
];

export default function RankingsPage() {
  const [cat, setCat] = useState("engineering");
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/rankings", { params: { category: cat, year: 2026 } }).then(r => setItems(r.data));
  }, [cat]);

  return (
    <div className="max-w-7xl mx-auto px-4 py-10" data-testid="rankings-page">
      <div className="overline text-sky-700 mb-2">EduTime Rankings</div>
      <h1 className="headline text-4xl md:text-5xl font-bold text-slate-900 mb-3">India's Top Institutions 2026</h1>
      <p className="text-slate-600 max-w-2xl mb-8">Independently curated rankings across engineering, medicine, management, universities and schools. Compare, filter, decide.</p>

      <div className="flex flex-wrap gap-2 mb-8" data-testid="rankings-tabs">
        {CATEGORIES.map(c => (
          <button key={c.slug} onClick={() => setCat(c.slug)}
            className={`px-4 py-2 rounded-full text-sm font-semibold transition-colors ${cat === c.slug ? "bg-sky-700 text-white" : "bg-slate-100 text-slate-700 hover:bg-sky-100"}`}
            data-testid={`ranking-tab-${c.slug}`}>
            {c.label}
          </button>
        ))}
      </div>

      <div className="card-soft overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm" data-testid="rankings-table">
            <thead className="bg-slate-50/70 border-b border-slate-100">
              <tr className="text-left text-slate-600">
                <th className="px-5 py-4 font-semibold w-16">Rank</th>
                <th className="px-5 py-4 font-semibold">Institution</th>
                <th className="px-5 py-4 font-semibold">Score</th>
                <th className="px-5 py-4 font-semibold">NAAC</th>
                <th className="px-5 py-4 font-semibold">NIRF</th>
                <th className="px-5 py-4 font-semibold">Type</th>
              </tr>
            </thead>
            <tbody>
              {items.map(r => (
                <tr key={r.id} className="border-b border-slate-50 hover:bg-sky-50/40">
                  <td className="px-5 py-4"><span className={`font-editorial text-2xl font-bold ${r.rank <= 3 ? "text-sky-700" : "text-slate-700"}`}>{r.rank}</span></td>
                  <td className="px-5 py-4 font-editorial font-semibold text-slate-900">{r.institution}</td>
                  <td className="px-5 py-4 text-slate-700">{r.score}</td>
                  <td className="px-5 py-4"><span className="tag-blue overline text-[10px] px-2 py-1 rounded-full">{r.naac}</span></td>
                  <td className="px-5 py-4 text-slate-700">{r.nirf}</td>
                  <td className="px-5 py-4 text-slate-500">{r.type}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {items.length === 0 && <div className="p-8 text-center text-slate-500">No data.</div>}
        </div>
      </div>
    </div>
  );
}
